import { createActions } from "@thewebops/admin-panel";

const actions = {
  downloadImportTemplate: createActions(`brand/downloadImportTemplate`),
};

export default actions;
